import { format } from '../utils/strings';
var useFormat = function (props) {
    return format(props);
};
export default useFormat;
